<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white rounded-lg shadow-l p-3 md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Le mie richieste</h1>

      <!--      <a (click)="onNavigate('form')" class="button">
              <span class="hidden md:inline">Nuova Richiesta</span>
              <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/><path d="M12 5v14"/>
              </svg>
            </a>-->
      <a routerLink="/modulo-di-richiesta"
         routerLinkActive="bg-gray-700"
         class="button primary">
        <span class="hidden md:inline">
          <img class="inline align-sub" ngSrc="/icons/plus.svg" alt="" height="20" width="20">Nuova Richiesta</span>
        <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M12 5v14"/>
        </svg>
      </a>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

    @if(requests$ | async; as requests) {
    <div class="overflow-auto w-full cursor-pointer">
      <div class="md:shadow-lg md:bg-gray-50 rounded-xl md:border md:border-gray-200">
        <div class="mx-auto">

          <table class="w-full border-collapse block md:table">

            <thead class="block md:table-header-group">
            <tr class="absolute -top-full -left-full md:relative md:top-auto md:left-auto md:table-row block border-b border-gray-200 bg-gray-100/50">
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('code')">ID
                @if(currentSort.field === 'code') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('state')">Stato
                @if(currentSort.field === 'state') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('label')">Richiesta
                @if(currentSort.field === 'label') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('code')">Codice
                @if(currentSort.field === 'code') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('date')">Data
                @if(currentSort.field === 'date') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
            </tr>
            </thead>

            <tbody class="block md:table-row-group">
              @for (r of requests; track $index) {
                <tr (click)="onRowClicked(r.uuid)"
                    class="bg-white block md:table-row mb-4 md:mb-0 rounded-2xl md:rounded-none border border-gray-100 md:border-b md:border-gray-200 shadow-sm md:shadow-none hover:bg-blue-50/30 transition-colors">

                  <div class="flex flex-col p-5 md:p-0 md:contents">

                    <div class="flex flex-col gap-3 md:contents">
                      <div class="flex justify-between items-start md:contents">

                        <td class="p-0 md:p-4 block md:table-cell text-sm font-mono text-gray-400 md:text-gray-900">
                          #{{ +r.code.split('-')[1] }}
                        </td>

                        <td class="p-0 md:p-4 block md:table-cell text-right md:text-left" style="min-width: 150px">

                      <span [class]="'px-3 py-1 rounded-full text-xs font-semibold border  min-w-[100px] text-center inline-block'" [ngClass]="getBadgeClass(r.state.state)">
                    {{ r.state.label }}
                  </span>
                        </td>

                      </div> <td class="p-0 md:p-4 md:pt-4 block md:table-cell text-lg md:text-sm font-bold md:font-medium text-gray-800">
                      <div>{{ r.request_type_id.label | truncate }} </div>
                    </td>
                    </div> <div class="flex justify-between items-end mt-5 pt-4 border-t border-gray-50 md:contents md:mt-0 md:pt-0 md:border-t-0">

                    <div class="flex flex-col md:contents">
                      <td class="p-0 md:p-4 md:pl-4 block md:table-cell text-sm text-gray-600 font-medium md:font-normal">
                        <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Codice</span><br class="md:hidden">
                        {{ r.code }}
                      </td>
                    </div>

                    <div class="flex flex-col text-right md:contents md:text-left">
                      <td class="p-0 md:p-4 block md:table-cell text-sm text-gray-600 italic md:not-italic font-medium md:font-normal">
                        <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Data Richiesta</span><br class="md:hidden">
                        {{ r.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                      </td>
                    </div>

                  </div> </div> </tr>
              } @empty {
                <div class="flex justify-center items-center h-24">
                  <h4 class="text-center absolute w-[300px] left-1/2 -translate-x-1/2">Nessun record trovato</h4>
                </div>
              }
            </tbody>
          </table>

        </div>
      </div>
    <app-pagination [params]="pagingParams" [totalItems]="totalRows" (pageChange)="goToPage($event)"></app-pagination>
    </div>
    }
    <div class="flex items-center justify-end mb-8">
      <button (click)="refresh()" class="button primary">
        <img class="inline align-sub" ngSrc="/icons/refresh.svg" alt="" height="20" width="20">
        Aggiorna Elenco
      </button>
    </div>


  </div>
</div>
